import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useLingui } from "@lingui/react/macro";
import { deducedError, useErrorMessageAlert } from "@/Utils/ErrorUtils";
import { moveGroupInRoute } from "@/api/Routes";

type UseReorderVisitsParams = {
  routeId: string;
};

export const useReorderVisits = ({ routeId }: UseReorderVisitsParams) => {
  const queryClient = useQueryClient();
  const { t } = useLingui();
  const { displayErrorMessageAlert } = useErrorMessageAlert();

  const { mutate: reorder, isPending: isReordering } = useMutation({
    mutationFn: ({
      groupId,
      orderedIds,
    }: {
      groupId: string;
      orderedIds: string[];
    }) => {
      return moveGroupInRoute(
        groupId,
        routeId,
        orderedIds.indexOf(groupId) + 1,
      );
    },
    onError: (err) => {
      displayErrorMessageAlert(
        `${t`Det gick inte att flytta besöket.`} ${deducedError(err)}`,
      );
    },
    onSuccess: async () => {
      return queryClient.invalidateQueries();
    },
  });

  return { reorder, isReordering };
};
